<template>
<w-settings-content-template>
  <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab">
    <el-tab-pane label="기본 이벤트" name="WCommonEvent" class="h100 w100">
      <w-common-event></w-common-event>
    </el-tab-pane>
    <el-tab-pane label="이벤트 등급" name="WEventLevel" class="h100 w100">
      <w-event-level :activeTab="activeTab"></w-event-level>
    </el-tab-pane>
    <el-tab-pane label="메시지 포맷" name="WMessageFormat" class="h100 w100" style="height: 100%;">
      <w-event-message-format></w-event-message-format>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WCommonEvent from './CommonEvent';
import WEventLevel from './EventLevel';
import WEventMessageFormat from './EventMessageFormat';

export default {
  name: 'WEventSettings',
  components: {
    WSettingsContentTemplate,
    WCommonEvent,
    WEventLevel,
    WEventMessageFormat,
  },
  props: {
    title: String,
  },
  data() {
    return {
      activeTab: 'WCommonEvent',
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/index.vue